import { Reducer, Action } from "redux";
import { ISocialMediaAnalysisHistoryState, KnownAction, REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY, SHOW_LOADER } from "./types";

export const reducer: Reducer<ISocialMediaAnalysisHistoryState> = (
    state: ISocialMediaAnalysisHistoryState | undefined,
    incomingAction: Action
): ISocialMediaAnalysisHistoryState => {
    if (state === undefined) {
        return { socialMediaAnalysisHistory: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY:
            return {
                ...state,
                socialMediaAnalysisHistory: action.socialMediaAnalysisHistory,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
